import { GALLERY } from "@/lib/content";
import { useReveal } from "@/lib/useReveal";

export const ProductShowcase = () => {
  const { ref, inView } = useReveal();
  return (
    <section className="bg-[var(--hp-charcoal)] py-12 sm:py-16 lg:py-20" ref={ref}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className={`mb-10 text-center hp-reveal ${inView ? "in-view" : ""}`}>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] text-[var(--hp-gold-light)]">
            Product Gallery
          </span>
          <h2 className="mt-3 font-display text-3xl uppercase text-white sm:text-4xl">
            Horse Power in the Spotlight
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-4">
          {GALLERY.map((g, i) => (
            <div
              key={i}
              data-testid={`showcase-image-${i}`}
              className={`group relative overflow-hidden rounded-2xl ring-1 ring-white/10 shadow-xl shadow-black/40 hp-reveal ${
                inView ? "in-view" : ""
              }`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <img
                src={g.url}
                alt={g.alt}
                className="aspect-square w-full object-cover transition duration-500 group-hover:scale-105"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 transition group-hover:opacity-100" />
              <div className="pointer-events-none absolute inset-0 rounded-2xl ring-2 ring-[var(--hp-crimson)]/0 transition group-hover:ring-[var(--hp-crimson)]/70" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
